import React, { useEffect, useState } from "react";
import LayoutNew from "../components/shared/LayoutNew";
import DesktopShell from "../components/shared/DesktopShell";
import { SettingsBody } from "../components/Setting";

// The Setting entry in the desktop nav bar routes here so the settings UI opens
// as a proper page inside the shared three-column shell (header + left Sports
// sidebar + center settings + right Open Bets dock), matching the reference
// site. On mobile the setting is still the full-screen overlay toggled from the
// header, so this route is only reached on desktop.
const SettingsPage = () => {
  const [isDesktop, setIsDesktop] = useState(
    () => window.matchMedia("(min-width: 1024px)").matches
  );
  useEffect(() => {
    const media = window.matchMedia("(min-width: 1024px)");
    const update = () => setIsDesktop(media.matches);
    media.addEventListener("change", update);
    return () => media.removeEventListener("change", update);
  }, []);

  const panel = (
    <div
      id="settingDiv"
      className="settings-page settings-page--inline"
      style={isDesktop ? undefined : { marginTop: "55px" }}
    >
      <SettingsBody />
    </div>
  );

  return isDesktop ? (
    <LayoutNew desktopHome>
      <DesktopShell activeNav="Setting">{panel}</DesktopShell>
    </LayoutNew>
  ) : (
    <LayoutNew>{panel}</LayoutNew>
  );
};

export default SettingsPage;
